import {
  accountBalance,
  accountBalanceForChildren,
  allBalance,
  allBalanceForChildren,
  casinoBalance,
  casinoBalanceForChildren,
  smFinance,
  virtualBalance,
  virtualBalanceForChildren,
  updateMenagerPercentage,
  updateAgentPercentage,
} from "../../js/api/profile.js";
import { getagents } from "../../js/api/getAgents.js";
import {
  getAccountBalanceTemplate,
  getSmFinanceTemplate,
} from "../templates/accountBalance.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";
let role = "";
let accountStartDate;
let accountEndDate;
let today = new Date();
let dd = String(today.getDate()).padStart(2, "0");
let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
let yyyy = today.getFullYear();

today = yyyy + "-" + mm + "-" + dd;
let startDate = today;
let endDate = today;
let childrenUsers = [];
let selectedChildrenUser;
let accountBalances;
let userCoins = [];
let dif_sport = 0;
let dif_sport_mng = 0;
let dif_casino = 0;
let dif_virtual = 0;
let difference = 0;

let SmFinances = {
  render: async () => {
    role = localStorage.getItem("role");

    let userCoinsView = ``;

    if (localStorage.getItem("coins")) {
      userCoins = JSON.parse(localStorage.getItem("coins"));

      userCoins.forEach((coin) => {
        userCoinsView += `<option value="${coin.id}">${_t("Monedha")}: ${Utils.currencyCode(coin.currency)}</option>`;
      });
    }

    let agents = await getagents(
      startDate,
      endDate,
      $("#accountBalanceUserCoinSelect").val(),
    );
    let agentsView = "";

    if (agents && agents.children_users.length !== 0) {
      childrenUsers = agents.children_users;
      agents.children_users.forEach((agent) => {
        console.log(agent);
        agentsView =
          agentsView + `<option value="${agent.id}">${agent.username}</option>`;
      });
    }

    // const account_balance = await accountBalance(startDate, endDate);

    // if (account_balance) {
    //   if (account_balance.length > 0) {
    //     account_balance.forEach((accBalance) => {
    //       accountBalanceView =
    //         accountBalanceView + getAccountBalanceTemplate(accBalance, role);
    //     });
    //   } else {
    //     accountBalanceView =
    //       accountBalanceView + getAccountBalanceTemplate(account_balance, role);
    //   }
    // }

    let view = /*html*/ `

<div class="changePercentageModal">
<input type="hidden" id="isForMng" value="0"/>
<a class="closeModalChangePercentageBtn">
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
    <g>
    \t<g>
    \t\t<path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717    L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859    c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287    l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285    L284.286,256.002z"/>
    \t</g>
    </g>
</svg>
</a>
<div class="addFundHolder">
    <span id="changePercentageTitle">${_t("Totali Sport Pika")}</span>
    <input type="text" placeholder="" id="changePercentageValueSport"><br><br><br>

    <span id="changePercentageTitle">${_t("Casino")}</span>
    <input type="text" placeholder="" id="changePercentageValueCasino"><br><br><br>

    <span id="changePercentageTitle">${_t("Virtual")}</span>
    <input type="text" placeholder="" id="changePercentageValueVirtual"><br><br><br>

    <a class="changePercentageBtn" id="changePercentageBtn">${_t("Ruaje")}</a>
</div>
</div>
            <div class="changePasswordHeader m-t-6">
                 <a class="backBtn">
                    <svg width="25" height="25" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#939393" d="M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"></path></svg>
                </a>
              
                 <span> ${_t("Financa")} <button id="myButtonControlID">${_t("Export to Excel")}</button></span>    
           </div>
           
           <div class="accountBalanceFilter">
             <span>${_t("Filtro me date")}:</span>
             <input type="text" readonly class="form-control" id="myCalendar">
           </div>
           <div class="myBetsAdministrationFilter ${
             role == "User" || role == "Agent" ? "dontAllow" : ""
           }">
       
             <span style="font-size: 10px;">Zgjidh nje perdorues:</span>
                <select name="accountAgentSelect " id="accountAgentSelect">
                    <option value="">${_t("Zgjidhni nje perdorues")}</option>
                    ${agentsView}
                </select>
             </div>
             <div class="myBetsAdministrationFilter ${
               role == "User" || role == "Agent" ? "makeFullWidth" : ""
             }">
             <span>${_t("Zgjidh valuten:")}</span>
      <select name="" id="accountBalanceUserCoinSelect">
      ${userCoinsView}
  </select>
          
            </div>
           <div id="accountBalanceWrapperExport" class="accountBalanceWrapper ${
             role != "User" ? "agentColumn" : ""
           }">
                <div class="accountBalanceContent">
                    <div class="accountBalanceContentHeader m-t-6">
                        <span style="width:16%;">${_t("Info")}</span>
                        <span style="width:14%;">${_t("Totali Sport")}</span>
                        <span style="width:14%;" id="pointTotalInfo">${_t("Totali Sport Pika")}</span>
                        <span style="width:14%;" id="casinoTotalInfo">${_t("Vegas Casino")}</span>
                        <span style="width:14%;" id="liveCasinoTotalInfo">${_t("LiveCasino")}</span>
                        <span style="width:14%;" id="virtualTotalInfo">${_t("Virtual")}</span>
                        <span style="width:14%;">${_t("Total Pika")}</span>
                    </div>
                    
                    <div class="accountBalanceRows" id="accountBalanceTbl">
                    
                    </div>
                    ${
                      role != "User"
                        ? `<div class="accountBalanceContentHeader m-t-6" id="accountBalanceContentFooter">
                
        </div><div class="accountBalanceContentHeader m-t-6" id="accountBalanceContentFooterSubTotal">
                
                      </div>
                      <div class="accountBalanceContentHeader m-t-6" id="accountBalanceContentFooterGrandTotal">
                
                      </div>
          `
                        : ""
                    }
                    
                </div>
            </div>
       `;
    return view;
  },
  after_render: async () => {
    $("[id$=myButtonControlID]").click(function (e) {
      let view = ``;
      let subTotalManager;
      for (let index = 0; index < accountBalances.length; index++) {
        const element = accountBalances[index];
        if (element.username == "_TOTAL_") {
          subTotalManager = element;
        } else {
          view += `<tr>
          <td>${element.username}</td>
          <td>${parseFloat(element.dif_sport ? element.dif_sport : 0).toFixed(2)}</td>
          <td>${parseFloat(element.dif_sport_mng ? element.dif_sport_mng : 0).toFixed(2)}</td>
          <td>${parseFloat(element.dif_casino ? element.dif_casino : 0).toFixed(2)}</td>
          <td>${parseFloat(element.dif_virtual ? element.dif_virtual : 0).toFixed(2)}</td>
          <td>${parseFloat(element.difference ? element.difference : 0).toFixed(2)}</td>
        <tr>`;
        }
      }

      view += `<tr>
      <td><b>TOTAL<b></td>
      <td>${parseFloat(dif_sport ? dif_sport : 0).toFixed(2)}</td>
      <td>${parseFloat(dif_sport_mng ? dif_sport_mng : 0).toFixed(2)}</td>
      <td>${parseFloat(dif_casino ? dif_casino : 0).toFixed(2)}</td>
      <td>${parseFloat(dif_virtual ? dif_virtual : 0).toFixed(2)}</td>
      <td>${parseFloat(difference ? difference : 0).toFixed(2)}</td>
    <tr>`;

      view += `<tr>
    <td><b>TOTAL ${$("#accountAgentSelect option:selected").text()}<b></td>
    <td> - </td>
    <td>${parseFloat(subTotalManager.dif_sport_mng ? subTotalManager.dif_sport_mng : 0).toFixed(2)}</td>
    <td>${parseFloat(subTotalManager.dif_casino ? subTotalManager.dif_casino : 0).toFixed(2)}</td>
    <td>${parseFloat(subTotalManager.dif_virtual ? subTotalManager.dif_virtual : 0).toFixed(2)}</td>
    <td>${parseFloat(subTotalManager.difference ? subTotalManager.difference : 0).toFixed(2)}</td>
  <tr>`;

      let tableContent = `<table>
      <thead valign="top">
      <tr>
      <th>${_t("Info")}</th>
      <th>${_t("Totali Sport")}</th>
      <th>${$("#pointTotalInfo").text()}</th>
      <th>${$("#casinoTotalInfo").text()}</th>
      <th>${$("#virtualTotalInfo").text()}</th>
      <th>${_t("Total Pika")}</th>
      </tr>
      </thead>
      <tbody>
      ${view}
      </tbody>
      
    </table>`;

      window.open(
        `data:application/vnd.ms-excel,filename=Raport_${$("#accountAgentSelect option:selected").text()}.xls` +
          encodeURIComponent(tableContent),
      );
      e.preventDefault();
    });

    $("body").on("click", "#pointTotalInfo", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      renderModal();
    });

    $("body").on("click", "#casinoTotalInfo", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      renderModal();
    });

    $("body").on("click", "#virtualTotalInfo", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      renderModal();
    });

    $("body").on("click", "#pointTotalInfoMng", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      renderModal(true);
    });

    $("body").on("click", "#casinoTotalInfoMng", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      renderModal(true);
    });

    $("body").on("click", "#virtualTotalInfoMng", function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      renderModal(true);
    });

    $("body").on("click", ".closeModalChangePercentageBtn", function () {
      $(".changePercentageModal").removeClass("clicked");
    });

    $("body").on("click", "#changePercentageBtn", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      $(".changePercentageModal").removeClass("clicked");
      let result;

      if ($("#isForMng").val() == "1") {
        result = await updateMenagerPercentage(
          selectedChildrenUser.id,
          $("#changePercentageValueSport").val() / 100,
          $("#changePercentageValueVirtual").val() / 100,
          $("#changePercentageValueCasino").val() / 100,
        );
      } else {
        result = await updateAgentPercentage(
          selectedChildrenUser.id,
          $("#changePercentageValueSport").val() / 100,
          $("#changePercentageValueVirtual").val() / 100,
          $("#changePercentageValueCasino").val() / 100,
        );
      }

      if (result.success) {
        $("#accountAgentSelect").val(selectedChildrenUser.id);
        let agents = await getagents(startDate, endDate, userCoins[0]);

        if (agents && agents.children_users.length !== 0) {
          childrenUsers = agents.children_users;
        }

        renderBalance();
      }
    });

    let today = new Date();
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();

    let months = [
      "Janar",
      "Shkurt",
      "Mars",
      "Prill",
      "Maj",
      "Qershor",
      "Korrik",
      "Gusht",
      "Shtator",
      "Tetor",
      "Nentor",
      "Dhjetor",
    ];
    let currentMonthDescription = `${months[today.getMonth()]}`;

    let ranges = {};
    ranges[_t("Sot")] = [moment(), moment()];
    ranges[_t("Dje")] = [
      moment().subtract(1, "days"),
      moment().subtract(1, "days"),
    ];
    ranges = {
      ...ranges,
      2022: [
        moment().subtract(1, "year").startOf("year"),
        moment().subtract(1, "year").endOf("year"),
      ],
      2021: [
        moment().subtract(2, "year").startOf("year"),
        moment().subtract(2, "year").endOf("year"),
      ],
    };

    ranges[`${currentMonthDescription}`] = [
      moment().startOf("month"),
      moment().endOf("month"),
    ];
    ranges[`${months[today.getMonth() == 0 ? 11 : today.getMonth() - 1]}`] = [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ];

    today = yyyy + "-" + mm + "-" + dd;
    let startDate = today;
    let endDate = today;

    accountStartDate = startDate;
    accountEndDate = endDate;

    $("#myCalendar").daterangepicker(
      {
        ranges: ranges,
        alwaysShowCalendars: false,
        startDate: moment().startOf("month"),
        endDate: moment().endOf("day"),
        opens: "center",
        linkedCalendars: false, // This prevents showing two months
        showCustomRangeLabel: false,
        opens: "center",
        locale: {
          direction: "ltr",
          format: "DD/MM/YYYY",
          separator: " - ",
          applyLabel: "Apliko",
          cancelLabel: "Anulo",
          fromLabel: "Da",
          toLabel: "A",
          customRangeLabel: "Personalizzata",
          daysOfWeek: ["DI", "HA", "MA", "ME", "EN", "PR", "SH"],
          monthNames: [
            "Janar",
            "Shkurt",
            "Mars",
            "Prill",
            "Maj",
            "Qershor",
            "Korrik",
            "Gusht",
            "Shtator",
            "Tetor",
            "Nentor",
            "Dhjetor",
          ],
          firstDay: 1,
        },
      },
      async function (start, end, label) {
        $("#contentLoader").append(
          '<div class="loaderWrapper">\n' +
            '            <div class="loader"></div>\n' +
            "        </div>",
        );
        let role = localStorage.getItem("role");
        console.log(
          "New date range selected: " +
            start.format("YYYY-MM-DD") +
            " to " +
            end.format("YYYY-MM-DD") +
            " (predefined range: " +
            label +
            ")",
        );
        let startDate = start.format("YYYY-MM-DD");
        let endDate = end.format("YYYY-MM-DD");
        accountStartDate = startDate;
        accountEndDate = endDate;

        renderBalance();

        $("body #accountBalanceTbl *").remove();
        $("body .loaderWrapper").remove();
      },
    );

    $("body").on("change", "#accountAgentSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      renderBalance();

      $("body #accountBalanceTbl *").remove();
    });

    $("body").on("change", "#accountBalanceUserCoinSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      renderBalance();
      $("body #accountBalanceTbl *").remove();
    });

    $("body").on("change", "#casinoAccountSelect", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      renderBalance();
      $("body #accountBalanceTbl *").remove();
    });

    renderBalance();
  },
};

async function renderBalance() {
  const id = $("#casinoAccountSelect").val();
  const userId = $("#accountAgentSelect").val();
  selectedChildrenUser = childrenUsers.find((a) => a.id == userId);
  if (selectedChildrenUser) {
    $("#pointTotalInfo").text(
      `Totali Sport Pika ${selectedChildrenUser.percentage * 100}%`,
    );
    $("#casinoTotalInfo").text(
      `Casino ${selectedChildrenUser.casino_percentage * 100}%`,
    );
    $("#virtualTotalInfo").text(
      `Virtual ${selectedChildrenUser.virtual_percentage * 100}%`,
    );
  }

  dif_sport = 0;
  dif_sport_mng = 0;
  dif_casino = 0;
  dif_virtual = 0;
  difference = 0;

  let currency = $("#accountBalanceUserCoinSelect").val();
  accountBalances = await smFinance(
    userId,
    accountStartDate,
    accountEndDate,
    currency,
  );
  let totalAccountBalanceRow;

  let accountBalanceView = "";

  if (accountBalances) {
    accountBalances.forEach((accBalance) => {
      if (accBalance.username == "_TOTAL_") {
        totalAccountBalanceRow = accBalance;
      } else {
        dif_sport += parseFloat(
          accBalance.dif_sport ? accBalance.dif_sport : 0,
        );
        dif_sport_mng += parseFloat(
          accBalance.dif_sport_mng ? accBalance.dif_sport_mng : 0,
        );
        dif_casino += parseFloat(
          accBalance.dif_casino ? accBalance.dif_casino : 0,
        );
        dif_virtual += parseFloat(
          accBalance.dif_virtual ? accBalance.dif_virtual : 0,
        );
        difference += parseFloat(
          accBalance.difference ? accBalance.difference : 0,
        );

        accountBalanceView =
          accountBalanceView + getSmFinanceTemplate(accBalance, role);
      }
    });
  }
  $("body #accountBalanceTbl").empty();
  $("body #accountBalanceTbl").append(accountBalanceView);

  if (role != "user") {
    $("body #accountBalanceContentFooter").empty();
    $("body #accountBalanceContentFooterSubTotal").empty();
    $("body #accountBalanceContentFooterGrandTotal").empty();

    $("body #accountBalanceContentFooterGrandTotal").append(`
    <span style="width:15%;">${$("#accountAgentSelect option:selected").text()} TOTAL</span>
    <span style="width:15%;">_</span>
    <span style="width:15%;">${(dif_sport_mng.toFixed(2) - parseFloat(totalAccountBalanceRow.dif_sport_mng ? totalAccountBalanceRow.dif_sport_mng : 0).toFixed(2)).toFixed(2)}</span>
    <span style="width:15%;">${(dif_casino.toFixed(2) - parseFloat(totalAccountBalanceRow.dif_casino ? totalAccountBalanceRow.dif_casino : 0).toFixed(2)).toFixed(2)}</span>
    <span style="width:15%;">${(dif_virtual.toFixed(2) - parseFloat(totalAccountBalanceRow.dif_virtual ? totalAccountBalanceRow.dif_virtual : 0).toFixed(2)).toFixed(2)}</span>
    <span style="width:15%;">${(difference.toFixed(2) - parseFloat(totalAccountBalanceRow.difference ? totalAccountBalanceRow.difference : 0).toFixed(2)).toFixed(2)}</span>`);

    $("body #accountBalanceContentFooter").append(`
      <span style="width:15%;">TOTALI</span>
      <span style="width:15%;">${dif_sport.toFixed(2)}</span>
      <span style="width:15%;">${dif_sport_mng.toFixed(2)}</span>
      <span style="width:15%;">${dif_casino.toFixed(2)}</span>
      <span style="width:15%;">${dif_virtual.toFixed(2)}</span>
      <span style="width:15%;">${difference.toFixed(2)}</span>`);
    if (totalAccountBalanceRow) {
      $("body #accountBalanceContentFooterSubTotal").append(`
      <span style="width:15%;">${$("#accountAgentSelect option:selected").text()}</span>
      <span style="width:15%;">_</span>
      <span style="width:15%;" id="pointTotalInfoMng">${parseFloat(totalAccountBalanceRow.dif_sport_mng ? totalAccountBalanceRow.dif_sport_mng : 0).toFixed(2)}  (${selectedChildrenUser ? selectedChildrenUser.mng_percentage * 100 : ""}%)</span>
      <span style="width:15%;" id="casinoTotalInfoMng">${parseFloat(totalAccountBalanceRow.dif_casino ? totalAccountBalanceRow.dif_casino : 0).toFixed(2)}  (${selectedChildrenUser ? selectedChildrenUser.mng_casino_percentage * 100 : ""}%)</span>
      <span style="width:15%;" id="virtualTotalInfoMng">${parseFloat(totalAccountBalanceRow.dif_virtual ? totalAccountBalanceRow.dif_virtual : 0).toFixed(2)}  (${selectedChildrenUser ? selectedChildrenUser.mng_virtual_percentage * 100 : ""}%)</span>
      <span style="width:15%;">${parseFloat(totalAccountBalanceRow.difference ? totalAccountBalanceRow.difference : 0).toFixed(2)}</span>`);
    }

    //accountBalanceContentFooterSubTotal
  }
}

function renderModal(isForMng = false) {
  $(".changePercentageModal").addClass("clicked");
  $("#changePercentageTitle").text("Totali Sport Pika");
  if (isForMng) {
    $("#isForMng").val(1);
    $("#changePercentageValueSport").val(
      selectedChildrenUser.mng_percentage * 100,
    );
    $("#changePercentageValueCasino").val(
      selectedChildrenUser.mng_casino_percentage * 100,
    );
    $("#changePercentageValueVirtual").val(
      selectedChildrenUser.mng_virtual_percentage * 100,
    );
  } else {
    $("#isForMng").val(0);
    $("#changePercentageValueSport").val(selectedChildrenUser.percentage * 100);
    $("#changePercentageValueCasino").val(
      selectedChildrenUser.casino_percentage * 100,
    );
    $("#changePercentageValueVirtual").val(
      selectedChildrenUser.virtual_percentage * 100,
    );
  }
}

export default SmFinances;
